import React, { useState, useEffect } from "react";
import VehiclesOverviewDialog from "./VehiclesOverviewDialog";
import VehiclesEditDialog from "./VehiclesEditDialog";
import VehiclesUploadDialog from "./VehiclesUploadDialog";
import API from "../../../utils/axios";
import { connect } from "react-redux";
import {
  setVehicles,
  setSelectedVehicles,
  setVehicleTypes
} from "../../../store/actions/project";
import { Route, useRouteMatch } from "react-router-dom";

function VehiclesDialog({
  saveDisabled,
  setSaveDisabled,
  setVehicles,
  setSelectedVehicles,
  setVehicleTypes,
  plan,
  projectId,
  openFromPayment,
  ...props
}) {
  const [currentAction, setCurrentAction] = useState("overview");
  const [uploadOpen, setUploadOpen] = useState(false);
  const [currentVehicleId, setCurrentVehicle] = useState(null);
  const [loadingVehicles, setLoadingVehicles] = useState(false);

  useEffect(() => {
    setSaveDisabled(true);

    // Update vehicle info from api, when opening vehicles dialog
    if (!loadingVehicles && props.open) {
      setLoadingVehicles(true);
      const url = sessionStorage.currentProject
        ? `/v1/projects/${sessionStorage.currentProject}/vehicles`
        : "";
      Promise.all([API.get("/v1/vehicles"), url && API.get(url)])
        .then(res => {
          console.log(res);
          setVehicleTypes(res[0].data);
          res[1] && setVehicles(res[1].data);

          // Set selected vehicles
          const selectedVehicles = res[1]
            ? res[1].data
                .filter(vehicle => vehicle.selected)
                .map(vehicle => vehicle.vehicle_id)
            : [];

          setSelectedVehicles(selectedVehicles);
        })
        .catch(error => console.log(error))
        .finally(() => setLoadingVehicles(false));
    }
    return () => {
      setCurrentAction("overview");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, setSaveDisabled, projectId]);

  useEffect(() => {
    setSaveDisabled(true);
  }, [currentAction, setSaveDisabled]);

  const match = useRouteMatch("/vehicles/upload");

  return (
    <>
      {!uploadOpen &&
        !match &&
        (["edit", "add"].includes(currentAction) ? (
          <VehiclesEditDialog
            {...props}
            open={props.open}
            setCurrentVehicle={setCurrentVehicle}
            currentVehicleId={currentVehicleId}
            saveDisabled={saveDisabled}
            setCurrentAction={setCurrentAction}
            setSaveDisabled={setSaveDisabled}
          />
        ) : (
          <VehiclesOverviewDialog
            {...props}
            open={props.open && currentAction === "overview"}
            setCurrentAction={setCurrentAction}
            setCurrentVehicle={setCurrentVehicle}
            setUploadOpen={openFromPayment ? setUploadOpen : null}
          />
        ))}
      {plan.ft_spreadsheet_upload &&
        (openFromPayment ? (
          uploadOpen && (
            <VehiclesUploadDialog
              {...props}
              setCurrentAction={setCurrentAction}
              setUploadOpen={openFromPayment ? setUploadOpen : null}
            />
          )
        ) : (
          <Route path="/vehicles/upload" exact>
            <VehiclesUploadDialog
              {...props}
              setCurrentAction={setCurrentAction}
            />
          </Route>
        ))}
    </>
  );
}

const mapStateToProps = state => ({
  plan:
    (state.auth.userData.organisationSite &&
      state.auth.userData.organisationSite.organisation.plan) ||
    {},
  projectId: state.project.id
});

export default connect(mapStateToProps, {
  setVehicles,
  setSelectedVehicles,
  setVehicleTypes
})(VehiclesDialog);
